<template>
   <div class="pricing-support-wrapper resource-details-wrapper resource-details-wrapper">
      <NotFound v-if="!supportPageData" />
      <div>
         <div
            ref="headerCon"
            class="resource-details-header"
            :style="{
               'background-color': supportPageData.content[0].body[0].externalProperties.background,
            }"
         >
            <div class="container container-1200">
               <div class="row">
                  <div class="col-12">
                     <div
                        class="d-flex align-items-center justify-content-between header-content-container"
                     >
                        <div class="header-text">
                           <h1 class="text-white">{{ supportPageData.content[0].header }}</h1>
                        </div>
                        <div class="header-img-container">
                           <img
                              ref="headerImg"
                              height="200px"
                              width="300px"
                              :src="supportPageData.content[0].body[0].rasterSource.file.url"
                              alt
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="resource-detail">
            <div class="container container-1200">
               <div class="row">
                  <div class="col-sm-12 col-md-8 col-lg-8 p-0 content-right pt-3">
                     <div class="resource detail-info description">
                        <div
                           v-html="markedRender(supportPageData.content[0].longDescription)"
                        ></div>
                     </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 bg-light-purple pl-3 pr-3 pt-1 pb-1">
                     <h4 class="text-center">Support</h4>
                     <div class="fc-tree-leaf-content pb-1">
                        <a
                           class="title-container"
                           href="https://www.fusioncharts.com/dev/upgrading/change-log"
                           ><i class=" fc_indicator_right tree-expando"></i
                           ><span class="fc-tree-leaf-text">CHANGE LOG</span></a
                        >
                     </div>
                     <div class="fc-tree-leaf-content pb-1">
                        <a
                           class="title-container"
                           href="https://www.fusioncharts.com/contact-support"
                           ><i class=" fc_indicator_right tree-expando"></i
                           ><span class="fc-tree-leaf-text">CONTACT TECH SUPPORT</span></a
                        >
                     </div>
                  </div>

                  <!-- table starts here -->
                  <div class="col-12 pt-6">
                     <h4 class="text-center pb-4">{{ supportPageData.content[1].header }}</h4>
                     <div class="card-group license-for-product">
                        <div class="card shadow web-app order-1">
                           <div class="card-body text-center PriceStack-container">
                              <div
                                 class="table-responsive1"
                                 v-html="markedRender(supportPageData.content[1].longDescription)"
                              >
                                 <!-- table will come here -->
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- Ends here -->
               </div>
            </div>
         </div>
         <!-- contactr plan start here here  -->
         <div class="pricing-cta-wrapper">
            <!-- contact sales conatiner-->
            <div class="bg-light-purple pt-4 pb-5 pt-md-6 pb-md-7">
               <div class="container container-1200">
                  <div class="row">
                     <div
                        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 content-wrapper text-center"
                     >
                        <h2>To upgrade to Platinum Support plan</h2>
                     </div>
                     <div class="col-12 text-center">
                        <div class="cta-buttons">
                           <button class="btn btn-primary-grad" @click="isModalVisible = true">
                              Contact Us
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- listing conatiner-->
            <div class="pt-4 pb-5 pt-md-6 pb-md-7">
               <div class="">
                  <div class="col-12">
                     <h2 class="text-center">{{ supportPageData.content[2].header }}</h2>
                     <div class="col-sm-12 col-md-8 col-lg-8 mx-auto">
                        <div
                           class="table-responsive1"
                           v-html="markedRender(supportPageData.content[2].longDescription)"
                        >
                           <!-- table will come here -->
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- Ends here -->
         <!-- -->
         <!-- Ends here-->
         <div class="request-demo pt-md-6 pb-7 bg-light-purple text-center">
            <div class="container container-1200">
               <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                     <h2 class="h2 pb-0">Can't decide which one is right for you?</h2>
                     <p>We're here to help you get started.</p>
                     <button class="btn btn-primary-grad" @click="isModalVisible = true">
                        Contact Us
                     </button>
                  </div>
               </div>
            </div>
         </div>
         <!--<b-modal v-model="isModalVisible" class="modal-consulting" centered hide-footer>
        <SalesForm
            :purpose-options="purpose_options"
            header="Contact our reseller manager"
            submit-text="Talk to us"
            :selected-index="0"
            source="Pricing - Reseller"
         />
      </b-modal>-->
         <b-modal v-model="isModalVisible" class="modal-consulting" centered hide-footer>
            <SalesForm
               :purpose-options="purpose_options"
               header="Contact our reseller manager"
               submit-text="Talk to us"
               :selected-index="0"
               source="Pricing - Reseller"
            />
         </b-modal>
         <!-- -->
      </div>
   </div>
</template>
<script>
import { mapState } from 'vuex';
import metaGenerator from '../util/meta.js';
import SalesForm from '../components/elforms/Sales';

export default {
   components: {
      SalesForm,
      // ComparisonTable,
   },
   data() {
      return {
         isModalVisible: false,
         isModalVisiblecontact: false,
         purpose_options: [
            {
               text: 'Licensing query for an enterprise plan',
               value: 'licensing-query-for-an-enterprise-plan',
            },
         ],
      };
   },
   computed: {
      ...mapState(['supportPageData']),
   },
   metaInfo() {
      return metaGenerator(this.supportPageData);
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('SUPPORT_PAGE_DATA_FETCH')]);
   },
};
</script>

<style lang="scss">
/* for new */
.check-box li {
   list-style: none;
   line-height: 30px;
}
.check-box li:before {
   content: '\E876';
   font-family: fusion-icon;
   width: 16px;
   height: 16px;
   border-radius: 50%;
   text-align: CENTER;
   line-height: 17px;
   font-size: 17px;
   color: #48b884;
   margin-right: 9px;
   background-color: rgba(109, 198, 157, 0.15);
}
i {
   font-size: 17px;
   padding-right: 9px;
}
</style>
<style lang="scss">
.resource-details-wrapper {
   width: 100%;
   .container-1200 {
      padding: 0 30px;
   }
   .resource-details-header {
      overflow: hidden;
      padding: 30px 0;
      transition: all ease 0.2s;

      .header-text {
         width: auto;
         color: white;
         z-index: 2;
         padding: 0 1.5rem;
      }

      .header-img-container {
         transition: all ease 0.35s;
         padding-top: 40px;
         transform: scale(1.7);

         &.zoomed {
            transform: scale(1);
         }
      }

      .header-content-container {
         flex-direction: column;
      }

      @media (min-width: 576px) {
         .header-img-container {
            transform: scale(1.5);
            padding-top: 0;
         }
      }
      @media (min-width: 768px) {
         .header-text {
            width: 58%;
         }
         .header-content-container {
            flex-direction: row;
         }
         .header-img-container {
            transform: scale(1.9);
            padding-top: 20px;
         }
      }
   }
   .table-responsive {
      display: table;
   }
   .resource-detail {
      padding: 3.2rem 0;
      background: #fff;

      @media (min-width: 576px) {
         padding: 6.5rem 0;
      }

      /*.form-wrapper {
         .btn {
            padding: 1.3rem 5.3rem;
            @media (min-width: 992px) {
               padding: 1.3rem 8.3rem;
            }
         }
      }*/

      .description {
         @media (min-width: 576px) {
         }
         @media (min-width: 768px) {
         }
         @media (min-width: 992px) {
            padding: 0 3rem;
         }
         @media (min-width: 1200px) {
         }
         p {
            color: #434456;
            margin-bottom: 2.5rem;
            line-height: 29px;
            font-size: 16px;
            // img {
            //    width: 100%;
            // }
         }

         h5 {
            color: #212344ad;
         }

         h2 {
            color: #212344;
            font-size: 30px;
            line-height: 38px;
         }
      }
   }

   @media (min-width: 768px) {
      .container-1200 {
         padding: 0 30px;
      }
   }

   .modal-header .close {
      padding: 1.3rem 2rem;
   }

   .modal-dialog {
      max-width: 500px;
      height: 65vh;
      margin-top: 20vh;

      .icon-container {
         margin-top: 100px;
         margin-bottom: 40px;
         i {
            font-size: 7.5rem;
            color: #62be93;
            font-weight: 600;
         }
      }

      @media (min-width: 800px) {
         max-width: 600px;
      }
      @media (min-width: 1200px) {
         max-width: 900px;
      }
   }
}

.fc-tree-leaf-content a:hover {
   text-decoration: none;
}
.resource-details-wrapper {
   table {
      width: 100%;
      margin-bottom: 10px;
      max-width: 100%;
      overflow-x: auto;
      display: block;
      @media (min-width: 768px) {
         max-width: auto;
         overflow-x: auto;
         display: table;
      }
      tr:nth-child(even) {
         // background-color: #f8f9fd;
      }
      tr:first-child td {
         text-align: center;
         font-weight: bold;
      }
      td:last-child {
         background: linear-gradient(90deg, #2cc7c0, #59d99d);
      }
      td {
         border: none;
      }
   }

   p {
      img {
         width: auto;
         max-width: 100%;
         height: auto;
      }
   }
}
.shadow {
   box-shadow: 0 10px 14px 0 rgba(33, 35, 68, 0.03) !important;
}

@media (min-width: 576px) {
   .card-group > .card {
      flex: 1 0 100%;
      margin-bottom: 1.5rem;
   }
}

@media (min-width: 768px) {
   .card-group > .card {
      flex: 1 0 0%;
   }
}
.card-group {
   padding-bottom: 1rem;
   @media (min-width: 768px) {
      padding-bottom: 6rem;
   }
   .card {
      border-radius: 5px;
      border: 1px solid rgba(62, 57, 107, 0.04);
      box-shadow: 0 8px 10px 0 rgba(0, 0, 0, 0.03);
      overflow: visible;
   }
}
.table td {
   width: 40%;
   text-align: left;
}
.PriceStack-container {
   box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14),
      0 9px 46px 8px rgba(0, 0, 0, 0.12);
}
</style>
